import { Divider, Drawer, Row, Col, Slider, Space, Button, Input, Skeleton, Checkbox, Spin, Tooltip, message } from "antd";
import React, { useEffect, useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined, FacebookOutlined, ShareAltOutlined } from '@ant-design/icons';
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import BMInput from "../../comps/BMInput";
import ColourPicker from "../../../globals/styles/ColourPicker";
import PresetPicker from "../../../globals/styles/PresetPicker";
import ButtonPicker from "../../../globals/styles/ButtonPicker";
import EventUI from "../../UI/EventUI";
import EventSelect from "../../EventSelect";
import { apiCall } from "../../../utils/Api";
import { PaddingHorizontalIcon, PaddingVerticalIcon, TwitterIcon, BlueskyIcon, MastodonIcon, ThreadsIcon } from "../../Icons";
import { tt_buy_titles, tt_name_block_warning, tt_sef_padding_x, tt_sef_padding_y } from "../../../utils/Utils";
import LinkPicker from "../../../globals/styles/LinkPicker";
import CategorySelector from "../../UI/CategorySelector";
import moment from "moment";

export default function SingleEventFeature(props) {

    const { view = "desktop" } = props;
    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [template,] = useTemplate();
    const [eventData, setEventData] = useState({})
    const [content, setContent] = useState(props.content);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    // Component specific
    const {
        width = 300,
        event = 0,
        background_colour = 0,
        padding_x = 20,
        padding_y = 20,
        title_preset = 0,
        description_preset = 0,
        date_preset = 0,
        button_type = 0,
        button_label = "Buy Books",
        button_align = "center",
        button_block = false,
        link_id = 0,

        // new
        next_event = false,
        categories = [],
    } = data;


    const fetchEvents = () => {


        if (next_event) {

            let _obj = {
                limit: 1,
                start_date: moment().format('YYYYMMDD')
            }

            if (categories) {
                _obj.categories = JSON.stringify(categories.map(item => item.id))
            }

            apiCall("event/v2/list", _obj, (_status, _result) => {
                if (_status) {
                    if (_result.rows.length > 0) {
                        setEventData(_result.rows[0])
                    } else {
                        setEventData({});
                    }
                } else {
                    message.error(_result.error)
                }
            }, "customer")

        } else {

            // No Event - Return
            if (event === 0) { return; }

            if (window.sitesettings.using_events_v2) {
                apiCall("event/v2/get", { event_id: event }, (_status, _result) => {
                    if (_status) {
                        setEventData(_result)
                    }
                }, "customer")
            } else {
                apiCall("event/get", { event_id: event }, (_status, _result) => {
                    if (_status) {
                        setEventData(_result)
                    }
                }, "customer")
            }


        }


    }
    useEffect(fetchEvents, [event, next_event, categories]);

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const marks = {
        200: <small>200px</small>,
        300: <small>300px</small>,
        400: <small>400px</small>,
    };


    const drawImages = () => {

        const {
            info = {},
            image_url = "",
            title = "",
            books = []
        } = eventData;
        const { name = "", img_path = "", book = [] } = info;

        let _books = book;
        let _image = img_path;
        let _title = name;

        if (window.sitesettings.using_events_v2) {
            _books = books;
            _image = image_url;
            _title = title;
        }

        let _w = "50%";

        if (!_image && books.length === 1) {
            _w = "100%";
        }

        return (
            <div style={{ width: '100%', textAlign: 'center' }}>
                <div style={{ width: '100%' }}>
                    {(_image && <img className="bm-img-link" onError={i => i.target.style.display = 'none'} src={_image} alt={_title} style={{ width: '100%', height: 'auto' }} />)}
                </div>
                <div style={{ display: 'flex', justifyContent : "center", gap: "10px", width: '100%', paddingTop: '10px' }}>
                    {(_books.map(item => {
                        return (
                            <div style={{ width: _w }}>
                                <img className="bm-img-link" onError={i => i.target.style.display = 'none'} src={"https://bookmanager.com/i/m?b=" + item.eisbn} alt={item.title} style={{ width: '100%', height: 'auto' }} />
                            </div>
                        )
                    }))}
                </div>
            </div>
        )
    }

    const drawButtons = (eventData) => {

        // Buy Tickets
        // Buy Books
        // RSVP
        const {
            info = {},
            books = [],
            tickets = [],
            ticket_label = "",
            rsvp_label = "",
            attendance = false
        } = eventData;
        const { book = [], ticket = [] } = info;

        let _tickets = ticket;
        let _tickets_label = "Tickets"
        let _books = book;
        let _books_label = button_label;
        let _attendance = attendance;
        let _rsvp_label = "";

        // New Events
        if (window.sitesettings.using_events_v2) {
            _tickets = tickets;
            _tickets_label = (ticket_label) ? ticket_label : "Tickets";
            _books = books;
            _rsvp_label = (rsvp_label) ? rsvp_label : "RSVP";
        }

        return (
            <>
                <div className="shim" /><div className="shim" />
                <div style={{ "display": "block", "textAlign": button_align }}>
                    {((_tickets.length > 0) && <Button block={button_block} className={"bm-btn-" + button_type}>{_tickets_label}</Button>)}
                    {((books.length > 0) && <Button block={button_block} className={"bm-btn-" + button_type}>{_books_label}</Button>)}
                    {((_attendance === "request") && <Button block={button_block} className={"bm-btn-" + button_type}>{_rsvp_label}</Button>)}
                </div>
            </>
        )
    }

    const drawButton = () => {
        const { info = {} } = eventData;
        const { book = [] } = info;
        if (book.length > 0) {
            return (<>
                {((button_label) && <>
                    <div className="shim" /><div className="shim" />
                    <div style={{ "display": "block", "textAlign": button_align }}>
                        <Button block={button_block} className={"bm-btn-" + button_type}>{button_label}</Button>
                    </div>
                </>)}
            </>)
        } else {
            return (<></>)
        }
    }

    const drawRender = () => {
        let _bgStyle = {
            background: getColor(background_colour, template),
            padding: padding_y + "px " + padding_x + "px",
        }
        let _wrapperStyle = {
            maxWidth: "100%",
        }
        const drawEvent = () => {
            if (event || (next_event && eventData)) {
                return (
                    <>
                        <EventUI
                            view={view}
                            link_id={link_id}
                            flourish={false}
                            event_id={event}
                            title_preset={title_preset}
                            date_preset={date_preset}
                            description_preset={description_preset}
                            event={eventData} />
                        {drawButtons(eventData)}
                    </>
                )
            } else {
                return (<Skeleton />)
            }
        }

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={_bgStyle}>
                    <div style={_wrapperStyle}>
                        <Row gutter={[20, 40]} style={{ "flexWrap": (view === "desktop") ? "nowrap" : "wrap" }}>
                            <Col flex={(width + "px")}>
                                {/* {drawEventImages()} */}
                                {drawImages()}
                                <br />
                                <div style={{ "textAlign": "center" }}>
                                    <Space>
                                        {window.storesettings.share_twitter && (<a target="_blank" rel="noopener noreferrer"><Button className={"bm-lnk-" + link_id} type="text" icon={<TwitterIcon style={{ "fontSize": "23px" }} />} /></a>)}
                                        {window.storesettings.share_facebook && (<a target="_blank" rel="noopener noreferrer"><Button className={"bm-lnk-" + link_id} type="text" icon={<FacebookOutlined style={{ "fontSize": "25px" }} />} /></a>)}
                                        {window.storesettings.share_bluesky && (<a target="_blank" rel="noopener noreferrer"><Button className={"bm-lnk-" + link_id} type="text" icon={<BlueskyIcon style={{ "fontSize": "25px" }} />} /></a>)}
                                        {window.storesettings.share_mastodon && (<a target="_blank" rel="noopener noreferrer"><Button className={"bm-lnk-" + link_id} type="text" icon={<MastodonIcon style={{ "fontSize": "25px" }} />} /></a>)}
                                        {window.storesettings.share_threads && (<a target="_blank" rel="noopener noreferrer"><Button className={"bm-lnk-" + link_id} type="text" icon={<ThreadsIcon style={{ "fontSize": "25px" }} />} /></a>)}
                                        <Button className={"bm-lnk-" + link_id} type="text" icon={<ShareAltOutlined style={{ "fontSize": "25px" }} />} />
                                    </Space>
                                </div>
                            </Col>
                            <Col flex="auto" style={{overflowWrap: "anywhere"}}>
                                {drawEvent()}
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        )
    }

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING</Divider>
                <div className="float-flex">
                    <Space>
                        <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_sef_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_sef_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                    <div></div>
                </div>
                <div className="shim" /> <div className="shim" />
                {/* WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGES WIDTH</Divider>
                <Slider defaultValue={width} onChange={(e) => setData({ ...data, "width": e })} marks={marks} min={100} max={500} />
                <div className="shim" /> <div className="shim" />

                {(window.sitesettings.using_events_v2 &&
                    <>
                        <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SHOW NEXT EVENT</Divider>
                        <div className="float-flex">
                            <Checkbox checked={next_event} onChange={(e) => setData({ ...data, "next_event": e.target.checked })} ><small>Show Next Event?</small></Checkbox>
                        </div>
                        <div className="shim" /> <div className="shim" />

                        {/* CATEGORIES */}
                        <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT CATEGORIES</Divider>
                        <CategorySelector disabled={!next_event} value={categories} onChange={(e) => setData({ ...data, "categories": e })} />
                        <div className="shim" /> <div className="shim" />
                    </>
                )}



                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT</Divider>
                <EventSelect disabled={next_event} setEventData={setEventData} value={event} onChange={(_v) => setData({ ...data, "event": _v })} />
                <div className="shim" /> <div className="shim" />
                {/* TITLE PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT TITLE PRESET</Divider>
                <PresetPicker value={title_preset} onChange={(e) => setData({ ...data, "title_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* DESCRIPTION PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT DATE PRESET</Divider>
                <PresetPicker value={date_preset} onChange={(e) => setData({ ...data, "date_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* DESCRIPTION PRESET */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">EVENT DESCRIPTION PRESET</Divider>
                <PresetPicker value={description_preset} onChange={(e) => setData({ ...data, "description_preset": e })} />
                <div className="shim" /> <div className="shim" />
                {/* BUTTON LABEL */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUY TITLES LABEL</Divider>
                <Tooltip title={tt_buy_titles}>
                    <Input style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "button_label": e.target.value })} value={button_label} placeholder="Label..." />
                </Tooltip>
                <div className="shim" /> <div className="shim" />
                {/* BUTTON TYPE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON TYPE</Divider>
                <ButtonPicker value={button_type} onChange={(e) => setData({ ...data, "button_type": e })} />
                <div className="shim" /> <div className="shim" />
                {/* ALIGN */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BUTTON FILL OR ALIGN</Divider>
                <div className="float-flex">
                    <Checkbox disabled={(!button_label)} checked={button_block} onChange={(e) => setData({ ...data, "button_block": e.target.checked })} ><small>Fit Container?</small></Checkbox>
                    <Spin style={{ cursor: (button_block) ? "not-allowed" : "pointer" }} indicator={<></>} spinning={button_block}>
                        <Space>
                            <div><PicLeftOutlined onClick={() => setData({ ...data, "button_align": "left" })} style={{ "color": (button_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                            <div><PicCenterOutlined onClick={() => setData({ ...data, "button_align": "center" })} style={{ "color": (button_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                            <div><PicRightOutlined onClick={() => setData({ ...data, "button_align": "right" })} style={{ "color": (button_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                    </Spin>
                </div>
                <div className="shim" /> <div className="shim" />

                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )
}